import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  CLOSE_IMPERSONATION_MODAL,
  GET_VENDOR_IMPERSONATION_STATE,
  OPEN_IMPERSONATION_MODAL,
} from "../redux/slices/impersonationSlice";
import { parseCookies } from "nookies";
import Cookies from "../types/cookies.type";
import useUserRole from "./useUserRole.hook";
import { StoreType } from "../redux/StoreType";

const useImpersonationModal = (userRole: string | string[]) => {
  const dispatch = useDispatch();

  const {
    impersonation: { isImpersonationModalOpen, isImpersonationSessionExpired },
  }: StoreType = useSelector(GET_VENDOR_IMPERSONATION_STATE, shallowEqual);

  const { isVendorAdmin } = useUserRole(userRole);

  const cookies: Cookies = parseCookies();

  useEffect(() => {
    if (
      isVendorAdmin &&
      isImpersonationSessionExpired &&
      !cookies.ImpersonatingUser
    ) {
      dispatch(OPEN_IMPERSONATION_MODAL());
    }
  }, [
    dispatch,
    isVendorAdmin,
    cookies.ImpersonatingUser,
    isImpersonationSessionExpired,
  ]);

  const closeImpersonationModal = () => {
    dispatch(CLOSE_IMPERSONATION_MODAL());
  };

  return {
    isImpersonationModalOpen: isImpersonationModalOpen,
    closeImpersonationModal,
    isImpersonationSessionExpired: isImpersonationSessionExpired,
  };
};

export default useImpersonationModal;
